export default class TextHelper {
    /* 
    * Formats strings that uses slashes (e.g. color variants):
    * 'red/black' -> 'red / black'
    */
    public static addWhitespacesAroundSlashes(value?: string): string {
        return value
            ?.split('/')
            .map((val) => val.trim())
            .join(' / ')
            .trim() ?? '';
    }
}
